"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
const rep_common_1 = require("@sa/rep-common");
class ReportContext {
    constructor(options) {
        var _a;
        this.getComponentContext = (id) => {
            const reportId = this.definition.id;
            const processingState = {
                createOptions: {
                    dataflowService: this.dataFlowService,
                    reportDefinition: this.definition,
                    serviceProvider: this._serviceProvider,
                },
                identification: {
                    componentId: id,
                    reportId: reportId,
                },
            };
            const pipelineResult = this._componentsContextsPipeline.execute(processingState);
            if (pipelineResult.componentContext === undefined) {
                throw new Error(`Component context ${id} for report ${reportId} does not registered`);
            }
            // try subscribe component to dataflow
            const componentContext = pipelineResult.componentContext;
            this.dataFlowService.subscribeComponent(componentContext);
            return componentContext;
        };
        this.definition = options.definition;
        this._serviceProvider = options.serviceProvider;
        // build dataflow service
        const parameters = this.definition.parameters;
        this.dataFlowService = new __1.DataFlowService({
            parameters: parameters,
            reportId: this.definition.id,
            middlewares: options.dataflowMiddlewares,
        });
        // create components contexts pipeline
        this._componentsContextsPipeline = new rep_common_1.PipelineSync();
        (_a = options.componentsContextsMiddlewares) === null || _a === void 0 ? void 0 : _a.forEach((x) => this._componentsContextsPipeline.use(x));
    }
    getService(id) {
        const result = this._serviceProvider.resolve(id);
        if (result === undefined) {
            throw new Error(`Service ${id} does not registered`);
        }
        return result;
    }
}
exports.ReportContext = ReportContext;
//# sourceMappingURL=ReportContext.js.map